import axios from "axios";

// Set API key on global axios instance — most components use axios directly
axios.defaults.headers.common["x-api-key"] = process.env.REACT_APP_API_KEY;

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	headers: {
		"x-api-key": process.env.REACT_APP_API_KEY,
	},
});

export default api;
